import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IAgentChatMessagesClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentChatMessagesClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class AgentChatMessagesClient implements IAgentChatMessagesClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, chatRoomId } = input;

        const PATH = `${API_LOCATION_URL}/agent/chat_messages?chat_room_id=${chatRoomId}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
